import React from 'react';

/**
 * Skel — the shape of something still loading (Apal 2026-11-03: "anything
 * that's loading must give loading effect so user clearly knows … be clear
 * about each section"). A soft sweep in the size of what will replace it, so
 * nothing jumps when the data lands. Size it with className (h-*, w-*).
 *
 * Rules (docs/UI_GUIDELINES.md §5c): the section's title stays real text —
 * only the data waits; no colour, count or tick is shown before the check
 * behind it has finished; when the data lands, wrap it in `cb-fade-in`.
 */
export const Skel = ({ className = '', testId, rounded = 'rounded-md' }) => (
  <span aria-hidden data-skel="" data-testid={testId} className={`cb-skel inline-block align-middle ${rounded} ${className}`} />
);

export default Skel;

const ROW_WIDTHS = ['w-16', 'w-24', 'w-12', 'w-20', 'w-14', 'w-28'];

/** Table rows still loading, under the table's real header — `cols` cells each. */
export const SkelRows = ({ cols, rows = 8, testId = 'table-skeleton', cellClass = 'py-2.5 px-3' }) => (
  <>
    {Array.from({ length: rows }, (_, r) => (
      <tr key={r} data-testid={r === 0 ? testId : undefined} className="border-b border-dark-700/40">
        {Array.from({ length: cols }, (_, c) => (
          <td key={c} className={cellClass}><Skel className={`h-3 ${ROW_WIDTHS[(r + c) % ROW_WIDTHS.length]}`} /></td>
        ))}
      </tr>
    ))}
  </>
);

// A table still loading: its real column names, the rows shimmer.
export const TableSkeleton = ({ columns, rows = 10, testId }) => (
  <div className="overflow-x-auto" data-testid={testId}>
    <table className="w-full">
      <thead><tr className="text-dark-400 text-xs uppercase tracking-wider">
        {columns.map(c => <th key={c} className="text-left py-3 px-2 font-medium">{c}</th>)}
      </tr></thead>
      <tbody><SkelRows cols={columns.length} rows={rows} cellClass="py-3 px-2" /></tbody>
    </table>
  </div>
);

